import React, { useEffect, useState } from 'react';

import useTranslate from '../../../../common/hooks/useTranslate';
import { useDispatch } from 'react-redux';

import { saveUserSettings } from '../../../services/userService';

import { POPUP } from '../../../../redux/types';

import { ISettingsCard } from '../../types/ISettingsCard';

import CardWrapper from '../../../ui/card/cardWrapper/cardWrapper';

import './userSettings.scss';

const UserSettings: React.FC<ISettingsCard> = ({ settings }) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  const slicerTooltipSetting = settings.find((setting) => {
    return setting.name === 'docuSlicerTooltipHidden';
  });

  const getTooltipLabel = (tooltipSettingHidden): string => {
    return tooltipSettingHidden === '1' ? t('PROFILE.TOOLTIP_HIDDEN') : t('PROFILE.TOOLTIP_SHOWN');
  };

  const tooltipSettingValue = slicerTooltipSetting && slicerTooltipSetting.value;

  const [tooltipValue, setTooltipValue] = useState(getTooltipLabel(tooltipSettingValue));

  const resetTooltipSettings = () => {
    const slicerTooltipSetting = { name: 'docuSlicerTooltipHidden', value: '0' };
    saveUserSettings(slicerTooltipSetting).catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }));
    setTooltipValue(t('PROFILE.TOOLTIP_SHOWN'));
  };

  useEffect(() => {
    setTooltipValue(getTooltipLabel(tooltipSettingValue));
  }, [settings]);

  return (
    <CardWrapper className='card-width'>
      <div className='title-flex-wrapper'>
        <span className='card-title'>{t('PROFILE.SETTINGS_TITLE')}</span>
      </div>
      {settings && (
        <div className='settings-row'>
          <div className='settings-label'>{t('PROFILE.TOOLTIP_SETTING')}</div>
          <div className='settings-value'>{tooltipValue}</div>
          <div>
            <button onClick={resetTooltipSettings} className='reset-settings-button pointer'
                    disabled={tooltipValue === 'Shown'}>
              {t('PROFILE.RESET_SETTING')}
            </button>
          </div>
        </div>
      )}
    </CardWrapper>
  );
};

export default UserSettings;
